// extracted by mini-css-extract-plugin
export var marginNegative = "_7f-5 _7f-3 _7f-1";
export var marginPositive = "_7f-4 _7f-3 _7f-1";
export var modalContent = "_7f-6";
export var samplesTable = "_7f-8";
export var samplesTableContainer = "_7f-7";
export var statBox = "_7f-a";
export var tableCell = "_7f-1";
export var tableCellCenter = "_7f-2 _7f-1";
export var tableCellRight = "_7f-3 _7f-1";
export var tableHeader = "_7f-0";
export var trackingNumber = "_7f-9";